import {
  getCustomTypes,
  getCustomTypeById,
  createCustomType,
  updateCustomType,
  deleteCustomType,
  duplicateContentModal,
  deleteContent
} from '../services/napi';
import {
  CUSTOM_TYPE_FETCH_SUCCESS,
  CUSTOM_TYPE_FETCH_FAIL,
  CUSTOM_TYPE_FETCH_BY_ID_SUCCESS,
  CUSTOM_TYPE_FETCH_BY_ID_FAIL,
  CUSTOM_TYPE_CREATE_SUCCESS,
  CUSTOM_TYPE_SET_DRAFT,
  CUSTOM_TYPE_DELETE,
  CUSTOM_TYPE_UPDATE_SUCCESS
} from '../constant/actionType';

function fetchCustomTypeError() {
  return {
    error: 'CUSTOM_TYPE_FETCH_FAIL',
    type: CUSTOM_TYPE_FETCH_FAIL
  };
}

function fetchCustomTypeByIdError() {
  return {
    error: 'CUSTOM_TYPE_FETCH_BY_ID_FAIL',
    type: CUSTOM_TYPE_FETCH_BY_ID_FAIL
  };
}

function createCustomTypeSuccess(data) {
  return { data, type: CUSTOM_TYPE_CREATE_SUCCESS };
}

function updateCustomTypeSuccess(data) {
  return { data, type: CUSTOM_TYPE_UPDATE_SUCCESS };
}

export function fetchCustomType() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getCustomTypes(projectId);

      dispatch({ data: response.data, type: CUSTOM_TYPE_FETCH_SUCCESS });
    } catch (error) {
      console.error(error);
      dispatch(fetchCustomTypeError());
    }
  };
}

export function fetchCustomTypeById(id, updateDraft = false) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await getCustomTypeById(id, projectId);

      dispatch({ data: response.data, type: CUSTOM_TYPE_FETCH_BY_ID_SUCCESS });

      if (updateDraft) {
        dispatch({
          data: { customTypeDraft: response.data.customType, merge: false, reset: false },
          type: CUSTOM_TYPE_SET_DRAFT
        });
      }
    } catch (error) {
      dispatch(fetchCustomTypeByIdError());
    }
  };
}

export function setCustomTypeDraft(customTypeDraft) {
  return async (dispatch) => {
    try {
      dispatch({ data: { customTypeDraft }, type: CUSTOM_TYPE_SET_DRAFT });
    } catch (error) {
      console.error('FAILED TO SET CUSTOM TYPE DRAFT');
    }
  };
}

export function createCustomTypeAction(onCreateSuccess) {
  return async (dispatch, getState) => {
    try {
      const { customTypeDraft } = getState().customType;
      const { _id: projectId } = getState().project.currentProject;

      customTypeDraft.isPublic = true;
      customTypeDraft.type = 'single';
      customTypeDraft.languages = ['en', 'ka'];
      customTypeDraft.template = {};

      const response = await createCustomType(customTypeDraft, projectId);

      dispatch(createCustomTypeSuccess(response.data));
      dispatch(fetchCustomType());
      if (onCreateSuccess) {
        onCreateSuccess();
      }
    } catch (error) {
      console.error('FAILED TO CREATE CUSTOM TYPE');
    }
  };
}

export function deleteCustomTypeAction(itemId, contentIds) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;

      if (contentIds.length >= 1) {
        await Promise.all(
          contentIds.map(async (id) => {
            await deleteContent(id, projectId);
          })
        );
      }

      await deleteCustomType(itemId, projectId);

      const response = await getCustomTypes(projectId);
      dispatch({ data: response.data, type: CUSTOM_TYPE_DELETE });
    } catch (error) {
      console.error(`FAILED TO DELETE CUSTOM TYPE: ${error}`);
    }
  };
}

export function updateCustomTypeAction(customTypeId, onUpdateSuccess) {
  return async (dispatch, getState) => {
    try {
      const { customTypeDraft } = getState().customType;
      const { _id: projectId } = getState().project.currentProject;

      customTypeDraft.isPublic = true;
      customTypeDraft.type = 'single';
      customTypeDraft.languages = ['en', 'ka'];

      const response = await updateCustomType(customTypeDraft, customTypeId, projectId);

      dispatch(updateCustomTypeSuccess(response.data));
      dispatch(setCustomTypeDraft({}));
      onUpdateSuccess();
    } catch (error) {
      console.error('FAILED TO UPDATE CUSTOM TYPE');
    }
  };
}

export function contentModalDuplicate(customTypeId, body, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      await duplicateContentModal(projectId, customTypeId, body);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error(`FAILED TO DUPLICATE: ${error}`);
    }
  };
}
